import { devSipherAgiCdn, proSipherAgiCdn } from "@/constants";
import { useCallback } from "react";

export const useConversationAvatar = () => {
  const sipherAgiCdn = process.env.NEXT_PUBLIC_ENV === "production" ? proSipherAgiCdn : devSipherAgiCdn;
  const fullAvatarUrl = useCallback((fileId: string) => {
    if (fileId !== "" && fileId.indexOf("http") === -1) {
      return `${sipherAgiCdn}/${fileId}`;
    }
    return fileId;
  }, [sipherAgiCdn]);

  return {
    sipherAgiCdn,
    fullAvatarUrl,
  }
}

